import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterToolbar = ({ 
  categories, 
  selectedCategory, 
  onCategoryChange, 
  searchQuery, 
  onSearchChange,
  dateRange,
  onDateRangeChange,
  totalPosts,
  filteredPosts
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const categoryOptions = [
    { value: 'all', label: 'All Categories', key: 'category-all' },
    ...categories?.map(cat => ({ value: cat, label: cat, key: `category-${cat}` }))
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time', key: 'date-all' },
    { value: 'today', label: 'Today', key: 'date-today' },
    { value: 'week', label: 'This Week', key: 'date-week' },
    { value: 'month', label: 'This Month', key: 'date-month' },
    { value: 'year', label: 'This Year', key: 'date-year' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-md p-4 md:p-6 mb-6 md:mb-8">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center justify-between lg:justify-start">
          <div className="flex items-center space-x-2">
            <Icon name="Filter" size={20} color="var(--color-primary)" />
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground">
              Filters
            </h2>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setShowFilters(!showFilters)}
            iconName={showFilters ? 'ChevronUp' : 'ChevronDown'}
            iconPosition="right"
            className="lg:hidden"
          >
            {showFilters ? 'Hide' : 'Show'}
          </Button>
        </div>

        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <span className="font-medium text-foreground">{filteredPosts}</span>
          <span>of</span>
          <span className="font-medium text-foreground">{totalPosts}</span>
          <span>posts</span>
        </div>
      </div>
      <div className={`${showFilters ? 'block' : 'hidden'} lg:block mt-4 lg:mt-6`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="relative">
            <Input
              type="search"
              placeholder="Search articles, tags, authors..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="pl-10"
            />
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground pointer-events-none"
            />
          </div>

          <Select
            options={categoryOptions}
            value={selectedCategory}
            onChange={onCategoryChange}
            placeholder="Select category"
          />

          <Select
            options={dateRangeOptions}
            value={dateRange}
            onChange={onDateRangeChange}
            placeholder="Select date range"
          />
        </div>

        <div className="flex flex-wrap gap-2 mt-4">
          {selectedCategory !== 'all' && (
            <div className="flex items-center space-x-2 bg-primary/10 text-primary px-3 py-1 rounded-md text-sm">
              <span>Category: {selectedCategory}</span>
              <button
                onClick={() => onCategoryChange('all')}
                className="hover:bg-primary/20 rounded-full p-0.5 transition-base"
                aria-label="Clear category filter"
              >
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          {dateRange !== 'all' && (
            <div className="flex items-center space-x-2 bg-primary/10 text-primary px-3 py-1 rounded-md text-sm">
              <span>Date: {dateRangeOptions?.find(opt => opt?.value === dateRange)?.label}</span>
              <button
                onClick={() => onDateRangeChange('all')}
                className="hover:bg-primary/20 rounded-full p-0.5 transition-base"
                aria-label="Clear date filter"
              >
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          {searchQuery && (
            <div className="flex items-center space-x-2 bg-primary/10 text-primary px-3 py-1 rounded-md text-sm">
              <span>Search: "{searchQuery}"</span>
              <button
                onClick={() => onSearchChange('')}
                className="hover:bg-primary/20 rounded-full p-0.5 transition-base"
                aria-label="Clear search"
              >
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterToolbar;